import React from "react";

import {
  BrandLogo as BrandLogoBase,
  brandLogoHeightMap,
  type BrandLogoProps,
  defaultBrandLogoUrlConfigOptions,
  type SupportedBrand,
  supportedBrands
} from "@busbud/horizon";

import {
  isDynamicWhiteLabel,
  useWhitelabelContext
} from "@app/context/whitelabel-context";
import { useAppContext } from "@app/helpers/hooks";

type Props = Partial<Omit<BrandLogoProps, "brand">>;

export const BrandLogo: React.FC<Props> = ({ alt, ...restProps }) => {
  const { translator } = useAppContext();
  const { whitelabel } = useWhitelabelContext();
  const whitelabel_name = whitelabel?.name;

  const isHorizonSupportedBrand = isSupportedWhiteLabel(whitelabel_name);
  const brand = isHorizonSupportedBrand ? whitelabel_name : "busbud";

  const altText = alt
    ? alt
    : translator.t("!layout.header.brandlogo-alt", { brand });

  // TODO: move this alternative BrandLogoBase to Horizon
  if (
    !isHorizonSupportedBrand &&
    isDynamicWhiteLabel(whitelabel) &&
    whitelabel.logo
  ) {
    const {
      id,
      className,
      size = defaultBrandLogoUrlConfigOptions.size,
      variant = defaultBrandLogoUrlConfigOptions.variant
    } = restProps;
    const [, height] = brandLogoHeightMap[variant][size];

    return (
      <img
        id={id}
        className={className}
        style={{ height }}
        src={whitelabel.logo}
        alt={altText}
        {...restProps}
      />
    );
  }

  return <BrandLogoBase brand={brand} alt={altText} {...restProps} />;
};

const isSupportedWhiteLabel = (
  whitelabel: string | undefined = ""
): whitelabel is SupportedBrand => {
  return supportedBrands.includes(whitelabel);
};
